// Pure state machine of the guided first-run flow (shared by Eventos, Reservas and Canchas).
// Phases: "req" (steps needed to publish) -> "opc" (optional, skippable) -> "cierre" (summary).

export const initialFlowState = () => ({ fase: "req", paso: 0, opc: 0, estado: {} });

// Optional steps can hide themselves depending on what was answered before (e.g. coupons only if paid).
export const visibleOptionalSteps = (pasosOpc, data) =>
  pasosOpc.filter((p) => !p.si || p.si(data));

export const goBack = (s) => (s.fase === "req" && s.paso > 0 ? { ...s, paso: s.paso - 1 } : s);

// Back to the previous optional step (the first one has nothing before it: the record is already published).
export const goBackOptional = (s) => (s.fase === "opc" && s.opc > 0 ? { ...s, opc: s.opc - 1 } : s);

// Moves to the next required step; the last one is closed by `markPublished`, not by this.
export const goNextRequired = (s, totalReq) =>
  s.fase === "req" && s.paso < totalReq - 1 ? { ...s, paso: s.paso + 1 } : s;

// The record exists now: go to the first optional step, or straight to the summary if there are none.
export const markPublished = (s, visibleOpc) =>
  visibleOpc.length
    ? { ...s, fase: "opc", opc: 0, estado: {} }
    : { ...s, fase: "cierre", estado: {} };

// Resolves the current optional step ("hecho" or "saltado") and moves on, or closes after the last one.
export const resolveOptional = (s, visibleOpc, id, resultado) => {
  const estado = { ...s.estado, [id]: resultado };
  const idx = visibleOpc.findIndex((p) => p.id === id);
  const next = idx + 1;
  if (idx >= 0 && next < visibleOpc.length) return { ...s, estado, opc: next };
  return { ...s, estado, fase: "cierre" };
};

export const finishNow = (s) => ({ ...s, fase: "cierre" });

// Rows of the closing screen: every visible optional step as hecho / saltado / pendiente.
export const closingRows = (visibleOpc, estado) =>
  visibleOpc.map((p) => ({
    id: p.id,
    titulo: p.titulo,
    seccion: p.seccion,
    estado: estado[p.id] === "hecho" ? "hecho" : estado[p.id] === "saltado" ? "saltado" : "pendiente",
  }));
